module.exports = __webpack_public_path__ + "img/right-top-arrow.9761ff85.png";